module.exports = __webpack_public_path__ + "img/title2.d85be0f.png";